import { render, staticRenderFns } from "./WorkflowTransfer.vue?vue&type=template&id=68691f83&scoped=true"
import script from "./WorkflowTransfer.vue?vue&type=script&lang=js"
export * from "./WorkflowTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68691f83",
  null
  
)

export default component.exports